import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Routes from './components/Routes';
import Provider from './context/recipesProvider';
import './pages/css/FoodCard.css';
import './pages/css/Favorite.css';
import './pages/css/Login.css';
import './pages/css/Explore.css';
import './pages/css/IngredientNationality.css';
import './pages/css/FoodDetails.css';
import './pages/css/Done.css';

function App() {
  return (
    <Provider>
      <Routes />
    </Provider>
  );
}

export default App;
